import * as React from "react";
import * as csstips from "csstips";
import { connect, useSelector } from "react-redux";
import { style } from "typestyle";
import { lightgrey } from "../Generics/_colors";
import Button from "../Generics/Button";
import {
  getAuthState,
  getRouterState,
  getSiteState,
  IStoreState,
} from "../../redux/rootReducer";
import { IGcpAppDispatchProp } from "../../redux/store";
import { userClicksToBackofficeButton } from "../scenarios";
import CsvDownloadButton from "./CsvDownloadButton";
import CsvWgsDownloadButton from "./CsvWgsDownloadButton";
import GpxDownloadButton from "./GpxDownloadButton";
import {
  canViewExistingControls,
  getPayloadFromToken,
} from "../../redux/modules/auth/utils";
import { ISite } from "../../apiFacades/csu/site";

interface ISidebarFooterProps extends IGcpAppDispatchProp {
  returnUrl?: string;
  site: ISite;
}
const SidebarFooter: React.FunctionComponent<ISidebarFooterProps> = ({
  returnUrl,
  site,
  dispatch,
}: ISidebarFooterProps) => {
  const hasSrs = Boolean(site?.srs);

  const authState = useSelector(getAuthState);
  const { ACL } = getPayloadFromToken(authState.accessToken);
  const isPilot = canViewExistingControls(ACL);

  if (!hasSrs && !returnUrl) {
    return null;
  }

  return (
    <div
      className={style(
        {
          borderTop: `1px solid ${lightgrey}`,
          padding: "10px 16px",
        },
        csstips.verticallySpaced(8),
      )}
    >
      {returnUrl && (
        <Button
          stretched
          onClick={() => dispatch(userClicksToBackofficeButton())}
          label="To Backoffice"
        />
      )}

      {hasSrs && (
        <>
          <div
            className={style(
              {
                display: "flex",
              },
              csstips.horizontallySpaced(8),
            )}
          >
            <CsvDownloadButton isPilot={isPilot} />
            {!isPilot && <GpxDownloadButton />}
          </div>

          <div
            className={style(
              {
                display: "flex",
              },
              csstips.horizontallySpaced(8),
            )}
          >
            <CsvWgsDownloadButton />
          </div>
        </>
      )}
    </div>
  );
};

export default connect((store: IStoreState) => ({
  returnUrl: getRouterState(store).data.returnUrl,
  site: getSiteState(store).data,
}))(SidebarFooter);
